module.exports = __webpack_public_path__ + "static/media/Icon_HomeSecurity.637ffe08.png";